const INPUT_DATA = {
  COURSE_DATA: {
    itemData: {
      name: {
        value: "",
        type: "input",
      },
      description: {
        value: "",
        type: "textarea",
      },
    },
  },
  CONTACT_DATA: {
    itemData: {
      type: {
        value: "",
        type: "input",
      },
      name: {
        value: "",
        type: "input",
      },
      link: {
        value: "",
        type: "input",
      },
    },
  },
  DONATE_DATA: {
    itemData: {
      type: {
        value: "",
        type: "input",
      },
      name: {
        value: "",
        type: "input",
      },
      link: {
        value: "",
        type: "input",
      },
    },
  },
  ABOUT_DATA: {
    itemData: {
      content: {
        value: "",
        type: "textarea",
      },
    },
  },
  PUBLICATION_DATA: {
    itemData: {
      name: {
        value: "",
        type: "input",
      },
      description: {
        value: "",
        type: "textarea",
      },
    },
  },
  ACTIVITIE_DATA: {
    itemData: {
      name: {
        value: "",
        type: "input",
      },
      description: {
        value: "",
        type: "textarea",
      },
    },
  },
  SDGSPROJECT_DATA: {
    itemData: {
      name: {
        value: "",
        type: "input",
      },
      description: {
        value: "",
        type: "textarea",
      },
    },
  },
  INITIATIVE_DATA: {
    itemData: {
      name: {
        value: "",
        type: "input",
      },
      description: {
        value: "",
        type: "textarea",
      },
    },
  },
  CONFERENCE_DATA: {
    itemData: {
      name: {
        value: "",
        type: "input",
      },
      description: {
        value: "",
        type: "textarea",
      },
    },
  },
};

export default INPUT_DATA;
